
import React , {useState} from 'react'
import "./OldEventsSlider.css";

import Slider from "react-slick";

const NextArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Next" className={className + " fas fa-angle-right"} style={style} onClick={onClick} />
    )
}
const PrevArrow = (props)=> {
    const {className, style, onClick} = props;
    return (
        <div aria-label="Prev" className={className + " fas fa-angle-left"} style={style} onClick={onClick} />
    )
};

class OldEventsSlider extends React.Component {
        constructor(props) {
            super(props);            
            this.state = {
                tablet: window.innerWidth < 769,
                mobile: window.innerWidth < 520
            };
            window.addEventListener("resize", this.resize.bind(this));
        }
        resize(){
            let tablet= window.innerWidth < 769;
            let mobile= window.innerWidth < 520;
            if(mobile !== this.state.mobile || tablet !== this.state.tablet){
                this.setState({mobile:mobile,
                tablet:tablet})
            }
        }
        render() {
            const settings ={
                dots: false,
                infinite: true,
                speed:700,
                slidesToShow: 1,
                rows: 1,
                slidesPerRow: 1,
                slidesToScroll:1,
                centerMode:true,
                autoplay: false,
                autoplaySpeed: 0,
                swipeToSlide:true,
                nextArrow: <NextArrow/>,
                prevArrow: <PrevArrow/>,
                adaptiveHeight: false,
                centerPadding:  0
            }
    return (
        <React.Fragment>
            <div className="oldEventsSliderContainer">
                <Slider {...settings}>
                    {this.props.items.map((item,index) => (
                        <div className="gallery-item" key={"modSliderItem_"+index}>
                            <a href={item.FileRef} target="_blank">
                                <img src={item.FileRef+"?RenditionID=10"} alt="תמונת גלריה" className="img-fluid img-fluidOldSlider"/>
                            </a>
                        </div>
                    ))}
                </Slider>
            </div>
        </React.Fragment>
    );}
}

export default OldEventsSlider;





// import React , {useState} from 'react'
// import "./OldEventsSlider.css";

// import Slider from "react-slick";

// const NextArrow = (props)=> {
//     const {className, style, onClick} = props;
//     return (
//         <div aria-label="Next" className={className + " fas fa-angle-right"} style={style} onClick={onClick} />
//     )
// }
// const PrevArrow = (props)=> {
//     const {className, style, onClick} = props;
//     return (
//         <div aria-label="Prev" className={className + " fas fa-angle-left"} style={style} onClick={onClick} />
//     )
// };

// class OldEventsSlider extends React.Component {
//         constructor(props) {
//             super(props);            
//             this.state = {
//                 tablet: window.innerWidth < 769,
//                 mobile: window.innerWidth < 520
//             };
//             window.addEventListener("resize", this.resize.bind(this));
//         }
//         resize(){
//             let tablet= window.innerWidth < 769;
//             let mobile= window.innerWidth < 520;
//             if(mobile !== this.state.mobile || tablet !== this.state.tablet){
//                 this.setState({mobile:mobile,
//                 tablet:tablet})
//             }
//         }
//         render() {
//             const settings ={
//                 dots: false,
//                 infinite: true,
//                 speed:700,
//                 slidesToShow: 1,
//                 rows: 1,
//                 slidesPerRow: 1,
//                 slidesToScroll:1,
//                 centerMode:true,
//                 autoplay: false,
//                 autoplaySpeed: 0,
//                 swipeToSlide:true,
//                 nextArrow: <NextArrow/>,
//                 prevArrow: <PrevArrow/>,
//                 adaptiveHeight: false,
//                 centerPadding:  0
//             }
//     return (
//         <React.Fragment>
//             <div className="oldEventsSliderContainer">
//                 <Slider {...settings}>
//                     {this.props.items.map((item,index) => (
//                         <div className="gallery-item1" key={"modSliderItem_"+index}>
//                             <a href={item.FileRef} target="_blank">
//                                 <img src={item.FileRef+"?RenditionID=10"} alt="תמונת גלריה" className="img-fluidOldSlider"/>
//                             </a>
//                         </div>
//                     ))}
//                 </Slider>
//             </div>
//         </React.Fragment>
//     );}
// }

// export default OldEventsSlider;

